


   <app-contact-form-modal  *ngIf="organisaion" [orgaMail]="organisaion.email" #contactFormModal>

   </app-contact-form-modal>

  <div  *ngIf="event1 && housingPrincings" style="clear: both">
    <div *ngIf="checkEventVisibility()"><!--*ngIf="checkEventVisibility()"-->
      <div class="container" *ngIf="!embededMode">
        <section id="banner" class="banner" *ngIf="event1.image">
          <div class="banner-notify" *ngIf="isDraft()">{{'front_event.your_event_is_in_draft_mode_it_is_visible_only_by_you'| translate}}</div>
          <img src="{{event1.image|assetimage}}" onError="this.src='assets/imgs/banner.png'" alt="{{event1.name}}" class="event-detail-banner-img">
        </section>

        <section id="banner1" *ngIf="!event1.image">
          <div class="banner-img-wrapper flexible">
            <img src="assets/imgs/banner.png"  alt="Bannière de l'évènement mis en avant" class="width-100 height-100">
          </div>
        </section>
      </div>

      <!-- Event details -->
      <section id="event-details" style="padding-top: 0px!important;">

        <div class="container">
          <div class="row " *ngIf="!embededMode">

            <div class="col-xs-12 col-lg-12" *ngIf="event1">
              <div class="row">
                <div class="col-md-12">
                  <header class="section-header" style="border-bottom: unset!important;">
                    <h2 class="inline-block evt-date evt-date-size">{{buildDate()}}</h2>
                    <h4 class="inline-block evt-time">
                      <i class="fa fa-clock-o"></i>
                      {{ event1.start_hour| hourpipe }}
                    </h4>
                    <h1 class="evt-name-size" style="font-size: 1.8rem">{{event1.name}}</h1>
                  </header>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-lg-5" id="reservation-wrapper">

              <div class="card" *ngIf="!isEnd && event_has_Booking(event1) && isClosed">
                <div class="card-header">
                  <header> {{'front_event.booking_is_end'| translate}}</header>
                </div>
                <div class="card-body p-2">
                  {{'front_event.it_is_no_longer_possible_to_book_this_event'| translate}}
                </div>
              </div>
            </div>

          </div>

          <!--<div *ngIf="!EmailValidationMode && !InFormationCheck">
          <div class="container text-center" style="margin-bottom: 27px" *ngIf="!embededMode">
            <div [innerHTML]="Inscription.description">{{Inscription.description}}</div>

            <div style="font-weight: bold;margin-top: 10px;margin-bottom: 20px">
              <div   title="Demande de badge" href="javascript:void(0);" id="" class="inline-block text-uppercase col-md-3 validateCmd1">
                Demande de badge
              </div>
            </div>
            <div >
                <div>Attention: si vous souhaiter inscrire un autre collaborateur il faut utiliser une autre adresse mail </div>
                <div *ngIf="Inscription.show_one_bage_one_mail_message" >(Une adresse mail = Une accréditation)</div>
            </div>
          </div>
          </div>-->

          <!--<div *ngIf="EmailValidationMode || InFormationCheck">
            <div class="container text-center" style="margin-bottom: 27px" *ngIf="!embededMode">
              <div [innerHTML]="Inscription.description">{{Inscription.description}}</div>

              <div style="font-weight: bold;margin-top: 10px;">
                <a   title="Demande de badge" href="javascript:void(0);" id="your_accreit" class="inline-block text-uppercase col-md-3 validateCmd1">
                 Votre accréditation
                </a>
              </div>
            </div>
          </div>-->


          <div class="col-xs-12 col-lg-12 col-md-12" style="margin-top: 20px">
            <div style="background-color: #EEE" class="card event-reservation" [ngClass]="isDraftCls()" *ngIf="!isEnd && event_has_Booking(event1) && !isClosed">
              <div class="card-body" style="padding: 10px;">
                <div style="padding: 10px">
                  <div style="display: flex;background-color: white;justify-content: space-between;padding: 11px;border-bottom: solid 1px #EEE;" *ngIf="nberOfdaySelection">
                    <div style="text-transform: uppercase"> SEJOUR + ACTIVITE + PARTY</div>
                    <div>
                      <select  [(ngModel)]="nboOfDays" style="height: 36px;width: 59px;" name="" class="form-control" id="">
                        <option  *ngFor = 'let item of nbdaysArrays' value="{{ item }}" >{{ item}}</option>
                      </select>
                    </div>
                  </div>

                  <div style="background-color: white;padding: 11px;border-bottom: solid 1px #EEE;" *ngIf="housingSelection">
                    <div class="divContnet row col-md-12" *ngIf="housingGlobal">
                      <div  class="col-md-3" style=";height: 140px;margin-top: 5px;">
                         <img class="img-fluid" src="../../../assets/imgs/hostel.jpg"/>
                      </div>

                      <div class="booking-desc col-md-9" >
                        <h3 style="text-transform: uppercase;color: #16BAFF">HOTEL THB OCEAN</h3>
                        <p style="font-size: 15px;text-align: justify">
                          L’hôtel THB Ocean Beach est un hôtel réservé aux adultes situé face à la mer, le long de la baie de Sant Antoni, sur l’île d’Ibiza.
                          L’hôtel compte une terrasse exclusive avec piscine, jacuzzi et pool bar, aménagée avec lits balinais, chaises longues et parasols totalement gratuits. L’hôtel possède une petite salle de sport dont l’utilisation est gratuite et dispose d’un service de massages en plein air. La réception est à la disposition de nos clients 24 h/24 et le Wi-Fi est gratuit dans tout l’établissement.
                          Toutes les chambres de l’hôtel disposent de salle de bains complète, balcon et réfrigérateur.
                        </p>
                      </div>
                    </div>
                    <div  class="divContnet row col-md-12" *ngIf="housingGlobal">
                        <div style="margin-bottom: 5px;margin-left: auto" class="col-md-3">
                          <button (click)="moveToAddHousingMode()" class="btn1">je crée un hébergement </button>
                        </div>
                        <div class="col-md-3" style="margin-right: auto">
                          <button (click)="moveToJoinHousingMode()" class="btn1">je rejoins un hébergement </button>
                        </div>
                    </div>
                    <div *ngIf="!housingGlobal">
                      <div class="col-md-12" *ngIf="addHousingMode">
                        <h3 style="text-transform: uppercase;margin-top: 10px;text-align: center;color: #16BAFF;">créer un Hébergement</h3>
                        <div class="col-md-8" style="margin-top: 50px;text-align: -webkit-center;margin-left: auto;margin-right: auto;">
                          <div class="form-group col-md-8" style="text-align: -webkit-center">
                            <label for="type" style="text-transform: uppercase">TYPE D'hebergement</label>
                            <select (change)="calulTotalHousingSelect()" class="form-control" name="type" id="type" [(ngModel)]="housing">
                              <option [disabled]="canSelectHousing(house)" *ngFor="let house of housingPrincings" [ngValue]="house">{{house.label+' - '+house.price+' €'}}</option>
                            </select>
                          </div>
                          <div *ngIf="housing">{{'(CAPACITE MAX '+housing.nbofpersons+' PERSONNES)'}}</div>
                         <!-- <div class="form-group col-md-8" style="text-align: -webkit-center" *ngIf="housing && housing.label !='Suite'">
                            <label for="option" style="text-transform: uppercase">Option vue sur la mer</label>
                            <input (change)="viewOnCheck()" type="checkbox" id="option" class="form-control">
                          </div>-->
                        </div>
                      </div>

                      <div class="col-md-12" *ngIf="joinHousingMode">
                        <h3 style="text-transform: uppercase;margin-top: 10px;text-align: center;color: #16BAFF;">rejoindre un Hébergement</h3>
                        <div class="col-md-12" style="margin-top: 50px;text-align: -webkit-center">
                          <!--<div class="form-group col-md-4" style="text-align: -webkit-center;margin-left: auto">
                            <label for="roomNber" style="text-transform: uppercase">numéro de chambre</label>
                            <input type="text" id="roomNber" name="roomNber" class="form-control" [(ngModel)]="roomNber">
                          </div>-->

                          <div class="form-group col-md-6" style="text-align: -webkit-center;">
                            <label for="roomcode" style="text-transform: uppercase">code de chambre</label>
                            <input type="text" id="roomcode" name="roomcode" class="form-control" [(ngModel)]="roomcodeTocheck">
                          </div>
                        </div>
                        <div>
                          <div style="text-align: center">
                            <button class="btn2" (click)="checkroomAvailability()">Vérifier la disponibilité </button>
                          </div>
                        </div>
                        <div *ngIf="roomcodeResponse && !roomcodeResponse.msg" style="text-align: center;margin-top: 5px;">{{roomcodeResponse}}</div>
                        <div *ngIf="roomcodeResponse && roomcodeResponse.msg" style="text-align: center;margin-top: 5px;color: green">
                         <div>{{roomcodeResponse.msg}}</div>
                          <div>{{roomcodeResponse.pricing.label+'  '+roomcodeResponse.pricing.price+' €'}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="background-color: white;height: 70px;padding: 11px;padding-right: 17px;text-align: right">
                    <div  *ngIf="addHousingMode || joinHousingMode">
                      <div style="text-transform: uppercase">Total</div>
                      <div style="font-weight: bold;color: #16BAFF">{{Total.toFixed(2)+' €'}}</div>
                    </div>
                  </div>
                </div>

               <!-- <div *ngIf="event_has_Booking(event) && !EmailValidationMode && !InFormationCheck">

                  <div  *ngFor="let pricing of pricings">
                    <div class={{checkExhausted(pricing)}} style="border-bottom: 1px solid darkgrey">
                      <app-pricing-header [pricing]="pricing" [front_event]="front_event"></app-pricing-header>

                      <div   class="price-wrapper" [ngClass]="{'alert alert-danger': pricingIsToMuchSelected(pricing)}">
                        &lt;!&ndash;pas de cagnote ,normal&ndash;&gt;
                        <span  class="price {{pricing.codePromo?'linet':''}}" *ngIf="!pricing.open ">{{price(getPricingPrice(pricing))}}</span>

                        <span  class="price " *ngIf="pricing.codePromo">{{price(calculatePricingPriceAfterPromoApply(pricing))}}</span>

                        &lt;!&ndash;si cagnote&ndash;&gt;
                        <input *ngIf="pricing.open && !pricing.IsClosed" [ngClass]="{'alert alert-danger': (getPricingPrice(pricing)<1)}" min="1" (change)="changeListener($event,pricingsAndPrincingsInGroup)" style="display: inline-block" class="form-control pricing-selection" [ngModel]="getPricingPrice(pricing)"  type="number">

                        <select class="pricing-selection" *ngIf="!(pricing.Totalplace <= 0 && pricing.Totalplace != -1 && pricing.ShowNbPlace) && !pricing.IsComing && !pricing.IsClosed" type="number" [(ngModel)]="pricing.nbreTicket" value="{{pricing.nbreTicket}}" min="0"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" name="nbreTicket" >

                          <ng-container *ngIf="!pricing.selectable_q">
                            <option  *ngFor = 'let item of nbTicketArray' value="{{ item }}" >{{ item}}</option>
                          </ng-container>

                          <ng-container *ngIf="pricing.selectable_q">
                            <option  *ngFor = 'let item of  pricing.pricingSelectableArray' value="{{ item }}" >{{ item}}</option>
                          </ng-container>

                        </select>

                        <app-pricing-statut [pricing]="pricing"></app-pricing-statut>

                      </div>
                    </div>
                  </div>

                  &lt;!&ndash;<div class="alert alert-success flexible space-between" *ngFor="let code of codePromosActivated">
                    <div>
                    <span>
                   {{code.name+' activé'}}
                   <i class="fa fa-arrow-right"></i>
                   <span *ngIf="code.pricing">{{': '+code.pricing.label}}</span>
                   <span *ngIf="code.reduction_simple"> {{'- '+code.reduction_simple+' '+functionUtils.getPricingDeviseSymbole(event.currency)+' TTC'}}</span></span>
                      <span *ngIf="code.reduction_by_percentage"> {{'- '+code.reduction_by_percentage+' %'}}</span>
                      <span *ngIf="code.reduction_type == 'Gratuit'"> Gratuit</span>
                    </div>
                    <span class="pointer1" (click)="deleteCodePRomo(code)">Supprimer</span>
                  </div>

                  <div class="price-total"  *ngIf="event_has_Booking(event) && pricings || !allPricingAreFree(pricings)">
                    {{'front_event.total'| translate}}: <span class="price ">{{Total.toFixed(2) +' '+functionUtils.getPricingDeviseSymbole(devise)}}</span>
                  </div>

                  <div class="code-promo" *ngIf="!hasCodePromoClicked && event.codes.length > 0">
                    Vous avez un code de réduction: <span class="click-here pointer1" (click)="changeHasCodePromo()">Cliquez ici</span>
                  </div>

                  <div class="code-promo" *ngIf="hasCodePromoClicked">
                    <input class="form-control col-md-6 inline-block" [(ngModel)]="codePrmo"  placeholder="Entrer votre code"  type="text">  <span class="apply-code-btn pointer1" (click)="applycodePromo()">Appliquer</span>
                  </div>&ndash;&gt;

                </div>-->

               <!-- <div *ngIf="EmailValidationMode" style="background-color: white;padding-bottom: 20px">

                  <div class="form-group center">
                    <label style="margin-top: 30px;font-size: 22px">Email lié a votre demande d'accréditation</label>

                    <div class="center">
                      <input type="email" class="form-control col-md-5 inline-block" [(ngModel)]="validationEmail" >
                      <span style="color: red;display: block" *ngIf="checkingEmalError">Accréditation non trouvée</span>
                    </div>
                  </div>
                  <div style="margin-left: 33px;margin-top: 52px;cursor: pointer" (click)="openContactModal()">Vous avez un soucis et souhaitez  contacter l'organisateur ? <span style="color: var(&#45;&#45;btn-bgColor)">Contactez l'organisateur</span></div>
                </div>-->


              <!--  <div *ngIf="InFormationCheck" style="background-color: white;padding-bottom: 20px;padding-top: 31px;">

                  <h4 class="text-uppercase" style="margin-left: 16px;margin-bottom: 25px">Information</h4>
                  <div class="row col-md-12">
                    <div class="form-group col-md-4">
                      <label style="">Nom</label>
                      <div class="center">
                        <input type="text" class="form-control  inline-block" [(ngModel)]="CheckName">
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label style="">Prénom</label>
                      <div class="center">
                        <input type="text" class="form-control  inline-block" [(ngModel)]="CheckPname">
                      </div>
                    </div>

                    <div class="form-group col-md-4">
                      <label style="">Société</label>
                      <div class="center">
                        <input type="text" class="form-control  inline-block" [(ngModel)]="CheckSociety" >
                      </div>
                    </div>
                  </div>
                </div>-->
              </div>



              <div style="height: 70px" class="card-footer flexible space-between" *ngIf="event_has_Booking(event1) && housingPrincings">

                <div class="payment-icons" >
                  <div class="payment-icon__left">
                    <ul class="payment-icons__list list-inline">
                      <li class="list-inline-item">
                        <img src="assets/imgs/payment/visa.png" class="img-fluid" width="70" alt="..."/>
                      </li>
                      <li class="list-inline-item">
                        <img src="assets/imgs/payment/mastercard.png" class="img-fluid" width="70" alt="..."/>
                      </li>
                    </ul>
                  </div>
                  <div class="payment-icon__right">
                    <img src="assets/imgs/payment/badge_secu.png" style="margin-left: 40px;margin-bottom: 15px;" class="img-fluid" width="125" alt="..."/>
                  </div>
                </div>

                <a  style="margin-left: auto" *ngIf="!addHousingMode && !joinHousingMode && !housingGlobal" title="Poursuivre" href="javascript:void(0);" (click)="continueHousingBooking()" id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>

                <a  style="margin-left: auto" *ngIf="addHousingMode || joinHousingMode && roomcodeResponse && roomcodeResponse.pricing" title="Poursuivre" href="javascript:void(0);" (click)="poursuivre1(housingPrincings)" id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>


                <!--<a  style="margin-left: auto"  title="Poursuivre" href="javascript:void(0);" (click)="checkValidationEmailEmail()" id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>
-->
               <!-- <a  title="Poursuivre" style="margin-left: auto" *ngIf="InFormationCheck" href="javascript:void(0);" (click)="CheckInfo()"  id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>

                <a  title="Poursuivre" style="margin-left: auto" *ngIf="!InFormationCheck && !EmailValidationMode" href="javascript:void(0);" (click)="poursuivre(pricings)" id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>-->
              </div>

              <!--<div style="height: 70px" class="card-footer flexible space-between" *ngIf="event_has_Booking(event) && pricings">

                <div class="payment-icons" *ngIf="!EmailValidationMode && !allPricingAreFree(pricings)">
                  <div class="payment-icon__left">
                    <ul class="payment-icons__list list-inline">
                      <li class="list-inline-item">
                        <img src="assets/imgs/payment/visa.png" class="img-fluid" width="70" alt="..."/>
                      </li>
                      <li class="list-inline-item">
                        <img src="assets/imgs/payment/mastercard.png" class="img-fluid" width="70" alt="..."/>
                      </li>
                    </ul>
                  </div>
                  <div class="payment-icon__right">
                    <img src="assets/imgs/payment/badge_secu.png" style="margin-left: 40px;margin-bottom: 15px;" class="img-fluid" width="125" alt="..."/>
                  </div>
                </div>


                <a *ngIf="EmailValidationMode" style="margin-left: auto"  title="Poursuivre" href="javascript:void(0);" (click)="checkValidationEmailEmail()" id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>

                <a  title="Poursuivre" style="margin-left: auto" *ngIf="InFormationCheck" href="javascript:void(0);" (click)="CheckInfo()"  id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>

                <a  title="Poursuivre" style="margin-left: auto" *ngIf="!InFormationCheck && !EmailValidationMode" href="javascript:void(0);" (click)="poursuivre(pricings)" id="validateCmd1" class="inline-block text-uppercase col-md-3">
                  {{'front_event.continue'| translate}}
                  <i class="fa fa-arrow-circle-o-right"></i>
                </a>
              </div>-->
            </div>
            <div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
   <app-loading-component *ngIf="!(event1 && housingPrincings)"> </app-loading-component>
